// /concept — SeatFab-inspired homepage concept for MaJourneys.
// THROWAWAY TEST PAGE. Standalone route (no /$lang/ layout) so it's a clean
// canvas. Three on-brand design directions, flipped via the sticky switcher.
// All cards use real production data (see ./-concept/data.ts). Pick a winner,
// then rebuild it on the real home hooks under /$lang/.
import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { VariationDashboard } from "./-concept/variation-dashboard";
import { VariationHero } from "./-concept/variation-hero";
import { VariationTwoTone } from "./-concept/variation-twotone";

export const Route = createFileRoute("/concept")({
  component: ConceptPage,
});

const VARIATIONS = [
  { id: 1, label: "Concierge Dashboard", hint: "Sidebar · center rails · right rail", node: <VariationDashboard /> },
  { id: 2, label: "Spotlight Hero", hint: "Full-bleed hero · category bar", node: <VariationHero /> },
  { id: 3, label: "Two-Tone", hint: "Navy sidebar · insights band", node: <VariationTwoTone /> },
] as const;

function ConceptPage() {
  const [active, setActive] = useState(1);
  const current = VARIATIONS.find((v) => v.id === active) ?? VARIATIONS[0];

  return (
    <div className="font-sans">
      {/* Load display + icon fonts (same approach as /carousel) */}
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,400;0,9..144,500;1,9..144,400;1,9..144,500&family=Poppins:wght@400;500;600;700;800&display=swap');@import url('https://cdn.jsdelivr.net/npm/remixicon@4.5.0/fonts/remixicon.css');`}</style>

      {/* Sticky variation switcher */}
      <div className="sticky top-0 z-50 border-b border-white/10 bg-[#0a0820]/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1380px] flex-wrap items-center gap-3 px-4 py-3 lg:px-7">
          <span className="mr-1 text-[11px] font-bold uppercase tracking-[0.18em] text-[#E5B265]">
            Concept · /concept
          </span>
          <span className="hidden text-[12px] text-white/40 sm:inline">
            Homepage direction · pick one
          </span>
          <div className="ml-auto flex flex-wrap items-center gap-1.5">
            {VARIATIONS.map((v) => (
              <button
                key={v.id}
                type="button"
                onClick={() => setActive(v.id)}
                className={`flex items-center gap-2 rounded-full px-3.5 py-2 text-[13px] font-bold transition ${
                  active === v.id
                    ? "bg-[#E5B265] text-[#0a0820]"
                    : "bg-white/[0.06] text-white/70 hover:bg-white/10 hover:text-white"
                }`}
                title={v.hint}
              >
                <span
                  className={`grid h-5 w-5 place-items-center rounded-full text-[11px] ${
                    active === v.id ? "bg-[#0a0820] text-[#E5B265]" : "bg-white/10 text-white/60"
                  }`}
                >
                  {v.id}
                </span>
                <span className="hidden sm:inline">{v.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Active variation */}
      <div key={current.id}>{current.node}</div>
    </div>
  );
}
